module.exports = "/assets/5dec53d75f4f40924bf90e68477f7ecd.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/CF.png
// module id = 1263
// module chunks = 0